import script from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=7ab7cf06&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/cap-emploi/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab7cf06"]])

export default __exports__